




































































































































































































































































































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { getSignatureServer, performanceServer, siteManagementServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import { deepClone } from '@/util/deepClone';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  components: {},
})
export default class SiteDetails extends Vue {
  // 父组件传递过来的控制编辑页面: 1：主页面 2：编辑页面 3：新增下级页面 4：新增页面
  @PropSync('showFlag', Number) showWhatFlag!: number;
  @Prop(Object) row!: Record<string, any>; // 父组件传递过来的需要修改一行的数据
  a = '（<35ppm）';
  b = '（<10%）';
  c = '（<18%-21%）';

  imgPath: any = 'data:image/jpeg;base64,';
  private URLPath: any = publishObjectPath.imgPathWater;
  private CellGroupList: any = []; // 分析项目、合格标准
  private AnalysisLimitSpaceList: any = []; // 分析数据(可另附表)
  private AnalysisRadioactiveSource: any = []; // 分析数据(可另附表)
  private newAnalysisList: any = [];
  measureTemporaryElectrolList: any = [];
  electroEquipListList: any = [];
  private loading: any = false;
  private applyStaffSignature: any = '';

  // 表单数据
  private formData: any = {
    applyId: '',
    applyStaffId: '',
    applyStaffName: '',
    approvalFlowExampleId: '',
    controlsRecord: [],
    finishFlag: false,
    finishTime: '',
    id: '',
    processLog: [
      {
        actionList: [],
        afterFlowNode: '',
        afterFlowNodeName: '',
        beforeFlowNode: '',
        beforeFlowNodeName: '',
        endTime: '',
        flowExampleId: '',
        id: '',
        memberList: [
          {
            objId: '',
            objName: '',
            type: '',
          },
        ],
        operation: '',
        operationName: '',
        startTime: '',
        withdraw: false,
      },
    ],
    safetyMeasureRecord: [],
    safetyMeasureAnnexData: [],
    taskEndTime: '',
    taskStartTime: '',
    taskUnit: '',
    type: '',
    workOrder: '',
  };
  private safetyDisclosureArr: any = [];
  private discloserArr: any = [];

  private processLogData: any = [
    {
      beforeFlowNodeName: '负责人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '审核人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '批准人意见',
      actionList: [],
    },
    {
      beforeFlowNodeName: '验收评估',
      actionList: [],
    },
  ];
  private otherSafetyMeasure: any = '';
  private riskIdentifyValue: any = '';
  private relevanceOtherValue: any = '';
  private directorUnitNameValue: any = '';
  private projectNameValue: any = '';

  created() {
    this.$nextTick(() => {
      this.getData(this.row);
    });
  }

  getData(data: any) {
    this.loading = true;
    // 通过主键查询单条数据
    siteManagementServer.getSingleSiteManagementData(data.id).then((res: any) => {
      this.loading = false;
      // 中部动态内容处理--开始
      if (res.data.controlsRecord && res.data.controlsRecord.length > 0) {
        res.data.controlsRecord.forEach((r: any, index: any) => {
          if (r.title.indexOf('签名') !== -1) {
            res.data.controlsRecord.splice(index, 1);
          }
        });

        res.data.controlsRecord.map((item: any, index: any) => {
          if (item.controlsType === 'Radio' || item.controlsType === 'Text' || item.controlsType === 'Input') {
            item.value = item.value;
          }
          if (item.controlsType === 'ChoiceText') {
            let strValue: any = '';
            if (item.value) {
              if (item.value.choice && item.value.choice.length) {
                const choiceValue: any = item.value.choice.map((choiceItem: any) => choiceItem.value);
                strValue = choiceValue.join('、');
                if (item.value.text) {
                  strValue = strValue + '；' + item.value.text;
                }
              } else {
                strValue = item.value.text ? item.value.text : '';
              }
            } else {
              strValue = '';
            }
            item.value = strValue;
          }

          if (item.controlsType == 'AnalysisLimitSpace') {
            item.value.forEach(async (i: any) => {
              if (i.sign) {
                this.$set(i, 'signatureValue', '');
                const resInner: any = await this.getSignatureData(i.sign);
                i.signatureValue = resInner && resInner.signature ? resInner.signature : '';
              }
            });
            this.AnalysisLimitSpaceList = item.value ? item.value : [];

            res.data.controlsRecord.splice(index, 1);
          }
          if (item.controlsType == 'CellGroup') {
            this.CellGroupList = item.value;
          }
          if (item.controlsType == 'AnalysisRadioactiveSource') {
            this.AnalysisRadioactiveSource = item.value ? item.value : [];
          }

          if (item.controlsType === 'ContactPerson' || item.controlsType === 'ContactPersonMore') {
            const newArr: any = item.value.map((elem: any) => elem.name);
            item.value = newArr.join('、');
          }

          if (item.controlsType === 'Location') {
            if (item.value && item.value !== '' && item.value !== undefined && item.value !== null) {
              if (this.isJson(item.value)) {
                item.value = JSON.parse(item.value).info;
              } else {
                item.value = item.value.info;
              }
            } else {
              item.value = item.value;
            }
          }
        });
      }
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.title === '分析项目') {
          res.data.controlsRecord.splice(index, 1);
        }
        if (r.title === '分析数据') {
          this.newAnalysisList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-measureTemporaryElectro') {
          this.measureTemporaryElectrolList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-electroEquipList') {
          this.electroEquipListList = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-otherSafeStep') {
          this.otherSafetyMeasure = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-riskIdentify') {
          if (r.value) {
            this.riskIdentifyValue = r.value;
          }
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'WorkTicket-relevanceOther') {
          if (r.value && r.value.length) {
            r.value.forEach((relation: any) => {
              this.relevanceOtherValue += relation.workOrder + '  ';
            });
          }
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-directorUnitName') {
          this.directorUnitNameValue = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      res.data.controlsRecord.map((r: any, index: any) => {
        if (r.controlsId === 'workTicket-projectName') {
          this.projectNameValue = r.value;
          res.data.controlsRecord.splice(index, 1);
        }
      });
      this.formData = res.data;
      const arrControlsRecord: any = deepClone(res.data.controlsRecord);
      if (res.data.type === '高处安全作业票' || res.data.type === '有限空间安全作业票' || res.data.type === '动火安全作业票') {
        arrControlsRecord.splice(5, 0, {
          title: '作业单位',
          value: res.data.taskUnit,
        });
        this.formData.controlsRecord = arrControlsRecord;
      } else {
        this.formData.controlsRecord = res.data.controlsRecord;
      }

      const arr: any = res.data.processLog.splice(1);
      arr.map((r: any) => {
        r.actionList.forEach(async (i: any) => {
          this.$set(i, 'deptName', '');
          this.$set(i, 'postNames', '');
          this.$set(i, 'signatureValue', '');
          if (i.signature) {
            const resInner: any = await this.getSignatureData(i.signature);
            i.deptName = resInner && resInner.deptName ? resInner.deptName : '';
            i.postNames = resInner && resInner.postNames ? resInner.postNames : '';
            i.signatureValue = resInner && resInner.signature ? resInner.signature : '';
          }
          if (i.images) {
            this.$set(i, 'imgArr', []);
            const resImg: any = await this.getSysFile(i.images);
            i.imgArr = resImg ? resImg : [];
          }
        });
      });
      const safetyDisclosureObj: any = arr.filter((item: any) => item.beforeFlowNodeName === '安全交底人');
      if (safetyDisclosureObj && safetyDisclosureObj.length) {
        this.safetyDisclosureArr = safetyDisclosureObj[0].actionList;
      } else {
        this.safetyDisclosureArr = [];
      }
      const discloserObj: any = arr.filter((item: any) => item.beforeFlowNodeName === '接受交底人');
      if (discloserObj && discloserObj.length) {
        this.discloserArr = discloserObj[0].actionList;
      } else {
        this.discloserArr = [];
      }
      const filterProcessLogData: any = arr.filter((item: any) => item.beforeFlowNodeName !== '安全交底人' && item.beforeFlowNodeName !== '接受交底人');
      const log1: any = filterProcessLogData.filter((item: any) => item.beforeFlowNodeName === '负责人意见');
      if (log1 && log1.length && log1[log1.length - 1].actionList) {
        this.processLogData[0].actionList = log1[log1.length - 1].actionList.filter((item: any) => item.actionType !== 'rollback');
      }

      const log2: any = filterProcessLogData.filter((item: any) => item.beforeFlowNodeName === '审核人意见');
      if (log2 && log2.length && log2[log2.length - 1].actionList) {
        this.processLogData[1].actionList = log2[log2.length - 1].actionList.filter((item: any) => item.actionType !== 'rollback');
      }

      const log3: any = filterProcessLogData.filter((item: any) => item.beforeFlowNodeName === '批准人意见');
      if (log3 && log3.length && log3[log3.length - 1].actionList) {
        this.processLogData[2].actionList = log3[log3.length - 1].actionList.filter((item: any) => item.actionType !== 'rollback');
      }

      const log4: any = filterProcessLogData.filter((item: any) => item.beforeFlowNodeName === '验收评估');
      if (log4 && log4.length && log4[log4.length - 1].actionList) {
        this.processLogData[3].actionList = log4[log4.length - 1].actionList.filter((item: any) => item.actionType !== 'rollback');
      }
      /*this.processLogData.forEach((item: any, index: any) => {
          if (filterProcessLogData[index]) {
            this.processLogData[index].actionList = filterProcessLogData[index].actionList;
          } else {
            this.processLogData[index].actionList = [];
          }
        });*/
      this.getStaffSignatureByStaffId();

      // 中部动态内容处理--结束
    });
  }
  // 获取签名图片 根据人员id
  private getStaffSignatureByStaffId() {
    getSignatureServer.getStaffSignatureByStaffId(this.formData.applyStaffId).then((res: any) => {
      if (res.code === '200') {
        if (!res.data) {
          this.applyStaffSignature = '';
          // this.$message.warning('当前人员暂无签名');
        } else {
          this.applyStaffSignature = res.data.signature;
        }
      } else {
      }
    });
  }

  async getSysFile(ids: any) {
    const res: any = await performanceServer.getSysFile(ids);
    if (res.code === '200' && res.data.length) {
      return res.data;
    } else {
      return '';
    }
  }

  // 判断是否为json格式
  isJson(data: any) {
    if (typeof data === 'string') {
      try {
        const obj: any = JSON.parse(data);
        if (typeof obj === 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }

  /**
   * @desc 获取签名人信息
   * @param1 暂无
   * @returns 暂无
   */
  async getSignatureData(id: any) {
    if (id) {
      const res: any = await performanceServer.getStaffInfo(id);
      if (res.code === '200') {
        return res.data ? res.data : '';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  /**
   * @todo 后期需要优化的部分
   * @desc 点击关闭按钮，返回上一级.
   * @param1 暂无
   * @returns 暂无
   */
  close(): void {
    this.showWhatFlag = 1;
  }

  /**
   * 导出
   * */
  onExport() {
    const obj: any = {
      type: this.row.type,
      workOrder: this.formData.workOrder,
    };
    /*const exportContainer: any = document.getElementById('imageWrapper');
        downloadPDF(exportContainer, obj);*/
    const exportContainer: any = document.getElementById('imageWrapper');
    const pageHeight = (exportContainer.offsetWidth / 592.28) * 841.89;
    const wholeNodes: any = document.getElementsByClassName('whole-node');
    for (let i = 0; i < wholeNodes.length; i++) {
      const topPageNum = Math.ceil(wholeNodes[i].offsetTop / pageHeight);
      const bottomPageNum = Math.ceil((wholeNodes[i].offsetTop + wholeNodes[i].offsetHeight) / pageHeight);
      if (i && topPageNum !== bottomPageNum) {
        wholeNodes[i].style.borderTop = '2px solid #666666';
        const divParent = wholeNodes[i].parentNode;
        const newBlock: any = document.createElement('div');
        newBlock.className = 'emptyDiv';
        newBlock.style.background = '#ffffff';

        const _H = topPageNum * pageHeight - wholeNodes[i].offsetTop;
        newBlock.style.height = _H + 30 + 'px';
        divParent.insertBefore(newBlock, wholeNodes[i]);
      }
    }
    html2canvas(exportContainer, {
      allowTaint: true,
      useCORS: true,
    }).then((canvas: any) => {
      const emptyDiv: any = document.querySelectorAll('.emptyDiv');
      for (let node = 0; node < emptyDiv.length; node++) {
        emptyDiv[node].style.borderTop = 'none';
        emptyDiv[node].parentNode.removeChild(emptyDiv[node]);
      }
      const contentWidth = canvas.width;
      const contentHeight = canvas.height;
      const pageHeight = (contentWidth / 592.28) * 841.89;
      let leftHeight: any = contentHeight;

      let position: any = 0;
      const imgWidth = 592.28;
      const imgHeight = (592.28 / contentWidth) * contentHeight;
      const pageData = canvas.toDataURL('image/jpeg', 1.0);
      const pdf: any = new jsPDF('p', 'pt', 'a4');
      if (leftHeight < pageHeight) {
        pdf.addImage(pageData, 'JPEG', 10, position, imgWidth - 20, imgHeight);
      } else {
        while (leftHeight > 0) {
          pdf.addImage(pageData, 'JPEG', 10, position, imgWidth - 20, imgHeight);
          leftHeight -= pageHeight;
          position -= 841.89;
          if (leftHeight > 0) {
            pdf.addPage();
          }
        }
      }
      pdf.save(`${this.row.type} - ${this.formData.workOrder}` + '.pdf');
    });
  }

  imgPreview(e: any) {
    setTimeout(() => {
      const dom: any = document.getElementsByClassName('el-image-viewer__img');
      for (let i = 0; i < dom.length; i++) {
        dom[i].style.transform = 'scale(1) rotate(270deg)';
      }
    });
  }
  private previewImgList(imgData: any) {
    const arr: any = [];
    imgData.forEach((item: any) => {
      arr.push(`${this.URLPath}${item.path}`);
    });
    return arr;
  }
}
